import { render, staticRenderFns } from "./Facility.vue?vue&type=template&id=56ef90d2&scoped=true"
import script from "./Facility.vue?vue&type=script&lang=js"
export * from "./Facility.vue?vue&type=script&lang=js"
import style0 from "./Facility.vue?vue&type=style&index=0&id=56ef90d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ef90d2",
  null
  
)

export default component.exports